<template>
  <div class="scheduleAvailability">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      color="#5bad2b"
      :is-full-page="fullPage"
    ></loading>
    <div class="container mt-2" style="background: white;">
      <form @submit.prevent="addSheduletime" method="post">
      <h1
        class="contenthead
      " style="color: black;"
      >
        Availability
        <span
          class="btn"
          id="myavailbtn"
          style="float: right; "
          ><span style="float : left; display:inline-flex;"
            >
            <div class="myAvailability">
            <button @click="myavAialablityList()" class="btn avabtn" style="background: #5bad2b; color:white; "
              >My Availability</button
            >
          </div>
          <!-- Button trigger modal -->
          <button
          id="info"
            type="button"
            class="btn"
            style="float:left"
            data-toggle="modal"
            data-target="#exampleModalCenter"
          >
            <i
              class="fa fa-info-circle ibutton"
              ></i>
            Info
          </button>
          </span
          >
        </span>
      </h1>
      <br />
      <br>
      <br>
    <div class="grid-container" >
<ul class="nav nav-pills date-val mb-3" id="pills-tab" role="tablist">
        <li class="nav-item date-p" v-for="weekDay in list" :key="weekDay">
          <a
            v-on:click="getDay(weekDay)"
            class="nav-link active "
            id="activebtn"
            data-toggle="pill"
            href="#pills-home"
            role="tab"
            aria-controls="pills-home"
            aria-selected="true"
            :class="{
                    'is-invalid': date_required, 'green': disabletime
                  }"
            >{{ weekDay }}</a
          >
        </li>
      </ul>
      <div v-if="date_required" class="dterrormsg">Select a date*</div>
      </div>
      <hr />
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane show active"
          id="pills-home"
          role="tabpanel"
          aria-labelledby="pills-home-tab"
        >
          <div class="container" style="padding-top: 20px">
            <h3 class="settime" style="text-align : center ; color: black">Set Timings</h3>
            <div class="row" id="timepicker">
              <div class="col-xs-2 timeshow">
                <div class="form-group">
                  <label for="start_time"  class="col-form-label" style="color: black"
                    >Start Time</label
                  >
                  <div class="input-group date" id="time">
                    <select name="time" v-model="sttimes" class="sttime" id="time" style="border: 2px solid #eee;" :disabled="disabletime" :class="{
                    'is-invalid': sttimes_required,
                  }" @change="getTime($event)" @click="validTime()">
                      <option class="selectTime"  value="">Select Time</option>
    <option  v-for="get in yourTimeArray" :key="get.start_time" :value="get.id" :hidden="get.id < current_n" :selected = start >{{get.start_time}}</option>
  </select>
  <div v-if="sttimes_required" class="errormsg">Time is required*</div>
                  </div>
                </div>
              </div>
              <div class="col-xs-1"></div>
              <div class="col-xs-2 timeshow">
                <div class="form-group" id="time">
                  <label for="end_time" class="col-form-label" style="color: black">End Time</label>
                  <div class="input-group date" id="endTime">
                    <select name="time"  v-model="endtime" id="time" class="sttime" style="border: 2px solid #eee;" disabled>
                    <option value="" class="selectTime" style="color:black">Select Time</option>
                    <option v-for="get in yourTimeArray" :key="get.start_time" :value="get.id">{{get.start_time}}</option>
  </select>
                  </div>
                </div>
              </div>
              <br />
            </div>
            <div class="add">
                <button
                  id="add"
                  class="btn btn-success"
                  style="align-items: center"
                >
                  Add
                </button>
              </div>
          </div>
        </div>
      </div>
      <br />
      <!-- Modal -->
      <div
        class="modal fade"
        id="exampleModalCenter"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-xl modal-dialog-centered"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title" id="exampleModalLongTitle" style="color: black">
                Availability info
                <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" class="modalclosebutton">&times;</span>
              </button>
              </h3>
            </div>
            <div class="modal-body">
              <div class="container">
                <div class="availInfo" style="font-size:16px;">
                  <ul>
                    <li>
                      Marking available date and time is mandatory for sending
                      and receiving the interest request.
                    </li>
                    <li>
                      The Organization will give interest according to your
                      availability date and time specified.
                    </li>
                    <li>
                      Availability timings will be updated in one-hour format
                      (for ex. If Interviewer marks 1 pm to 5 pm as available,
                      then the system shall divide into one -hour format (1 pm-2
                      pm, 2 pm-3 pm, and 3 pm-4 pm)
                    </li>
                    <li>
                      By selecting Repeat for coming weeks, the system
                      automatically updates for coming days accordingly
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </form>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import Loading from 'vue-loading-overlay'
import { required } from 'vuelidate/lib/validators'
import Vuelidate from 'vuelidate'
import Vue from 'vue'
import momentsone from 'moment-timezone'
Vue.use(Vuelidate, axios)

export default {
  data () {
    return {
      list: [moment().format('ddd, DD MMM YYYY')],
      times: moment().format('HHmm'),
      stime: '',
      etime: '',
      fullPage: true,
      sttimes_required: false,
      date_required: false,
      currentTimeZone: momentsone.tz.guess(),
      listTimes: {
        user_id: this.$route.params.id,
        start_date: this.getdate,
        end_date: this.getdate,
        repeat: 'no',
        endVal: '',
        startVal: '',
        start_datetime: this.getdate + ' ' + this.start_time,
        end_datetime: this.getdate + ' ' + this.end_time
      },
      listDateTime: [],
      dataTime: [],
      userList: [],
      getdate: '',
      timeList: '',
      value: '',
      isLoading: false,
      submitted: false,
      yourTimeArray: [
        { start_time: '00:00', start: '0000', id: 1 },
        { start_time: '00:30', start: '0030', id: 2 },
        { start_time: '01:00', start: '0100', id: 3 },
        { start_time: '01:30', start: '0130', id: 4 },
        { start_time: '02:00', start: '0200', id: 5 },
        { start_time: '02:30', start: '0230', id: 6 },
        { start_time: '03:00', start: '0300', id: 7 },
        { start_time: '03:30', start: '0330', id: 8 },
        { start_time: '04:00', start: '0400', id: 9 },
        { start_time: '04:30', start: '0430', id: 10 },
        { start_time: '05:00', start: '0500', id: 11 },
        { start_time: '05:30', start: '0530', id: 12 },
        { start_time: '06:00', start: '0600', id: 13 },
        { start_time: '06:30', start: '0630', id: 14 },
        { start_time: '07:00', start: '0700', id: 15 },
        { start_time: '07:30', start: '0730', id: 16 },
        { start_time: '08:00', start: '0800', id: 17 },
        { start_time: '08:30', start: '0830', id: 18 },
        { start_time: '09:00', start: '0900', id: 19 },
        { start_time: '09:30', start: '0930', id: 20 },
        { start_time: '10:00', start: '1000', id: 21 },
        { start_time: '10:30', start: '1030', id: 22 },
        { start_time: '11:00', start: '1100', id: 23 },
        { start_time: '11:30', start: '1130', id: 24 },
        { start_time: '12:00', start: '1200', id: 25 },
        { start_time: '12:30', start: '1230', id: 26 },
        { start_time: '13:00', start: '1300', id: 27 },
        { start_time: '13:30', start: '1330', id: 28 },
        { start_time: '14:00', start: '1400', id: 29 },
        { start_time: '14:30', start: '1430', id: 30 },
        { start_time: '15:00', start: '1500', id: 31 },
        { start_time: '15:30', start: '1530', id: 32 },
        { start_time: '16:00', start: '1600', id: 33 },
        { start_time: '16:30', start: '1630', id: 34 },
        { start_time: '17:00', start: '1700', id: 35 },
        { start_time: '17:30', start: '1730', id: 36 },
        { start_time: '18:00', start: '1800', id: 37 },
        { start_time: '18:30', start: '1830', id: 38 },
        { start_time: '19:00', start: '1900', id: 39 },
        { start_time: '19:30', start: '1930', id: 40 },
        { start_time: '20:00', start: '2000', id: 41 },
        { start_time: '20:30', start: '2030', id: 42 },
        { start_time: '21:00', start: '2100', id: 43 },
        { start_time: '21:30', start: '2130', id: 44 },
        { start_time: '22:00', start: '2200', id: 45 },
        { start_time: '22:30', start: '2230', id: 46 },
        { start_time: '23:00', start: '2300', id: 47 },
        { start_time: '23:30', start: '2330', id: 48 }
      ],
      starttime: '',
      endtime: '',
      sttimes: '',
      errormsg: '',
      dterrormsg: '',
      current_n: 0,
      hiddenTrue: true,
      d: '',
      start: '',
      disabletime: false,
      myweekList: []
    }
  },
  components: {
    Loading
  },
  validations: {

    form: {
      starttime: { required }
    }

  },
  created () {
    localStorage.getItem('user_id')
    console.log(this.$route.params.id)
    if (!this.listTimes.start_date) {
      this.d = []
    }
    this.getmyWeekdays()
  },
  methods: {
    myavAialablityList () {
      this.$router.push('/myAvailability/' + this.$route.params.id)
    },
    moment () {
      return moment()
    },
    validTime () {
      if (!this.listTimes.start_date) {
        this.disabletime = true
        this.date_required = true
      } else {
        this.disabletime = false
        this.date_required = false
      }
    },
    getmyWeekdays () {
      axios.get(BaseURL + '/profile/get_last_21days')
        .then(response => {
          this.myweekList = response.data.userAvailabilityInfo
          console.log(this.myweekList)
        })
        .catch(e => {
          console.log(e)
        })
    },
    getDay (weekDay) {
      // date validation
      this.date_required = false
      this.disabletime = false
      this.listTimes.start_date = moment(weekDay).format('YYYY-MM-DD')
      this.getdate = weekDay
      if (this.getdate === this.list[0]) {
        this.hiddenTrue = true
        this.d = this.yourTimeArray.filter(function (item) {
          return Number(item.start) >= Number(this.times)
        }.bind(this))
        if (this.d.length > 0) {
          this.current_n = this.d[0].id
        } else {
          this.current_n = 0
        }
      } else {
        this.current_n = 0
      }
    },
    getTime (event) {
      this.sttimes_required = false
      this.starttime = Number(event.target.value)
      var start = this.yourTimeArray.find(item => item.id === Number(event.target.value))
      this.start = start.start_time
      var end = {}
      if (this.starttime === 47) {
        end = this.yourTimeArray.find(item => item.id === 1)
        this.endtime = 1
        this.end = end.start_time
      } else if (this.starttime === 48) {
        end = this.yourTimeArray.find(item => item.id === 2)
        this.endtime = 2
        this.end = end.start_time
      } else {
        end = this.yourTimeArray.find(item => item.id === Number(event.target.value) + 2)
        this.endtime = end.id
        this.start = start.start_time
        this.end = end.start_time
      }
    },
    addSheduletime (e) {
      // e.preventDefault()
      // time validations
      this.sttimes_required = false
      if (!this.listTimes.start_date) {
        this.date_required = true
        return false
      } else if (!this.sttimes) {
        this.sttimes_required = true
        return false
      } else {
        this.date_required = false
        this.sttimes_required = false
        this.submitted = true
        if (this.end === '00:00') {
          this.end = '24:00'
          this.endtime = '24:00'
        }
      }
      this.listTimes.start_datetime = this.listTimes.start_date + ' ' + this.start
      this.listTimes.end_datetime = this.listTimes.start_date + ' ' + this.end
      this.listTimes.end_date = this.listTimes.start_date
      const formData = new FormData()
      formData.append('user_id', this.listTimes.user_id)
      formData.append('start_date', this.listTimes.start_date)
      formData.append('end_date', this.listTimes.end_date)
      formData.append('starttime', this.starttime)
      formData.append('endtime', this.endtime)
      formData.append('repeat', this.listTimes.repeat)
      formData.append('start_datetime', this.listTimes.start_datetime)
      formData.append('end_datetime', this.listTimes.end_datetime)
      const data = {
        user_id: this.listTimes.user_id,
        start_date: this.listTimes.start_date,
        end_date: this.listTimes.end_date,
        starttime: this.start,
        endtime: this.end,
        repeat: this.listTimes.repeat,
        start_datetime: this.listTimes.start_datetime,
        end_datetime: this.listTimes.end_datetime,
        timezone: ''
      }
      if (this.currentTimeZone === 'America/New_York') {
        data.timezone = 'EST'
      } else {
        data.timezone = 'IST'
      }
      this.isLoading = true
      axios.post(BaseURL + '/profile/availability_repeat', { formData: data })
        .then((response) => {
          this.isLoading = false
          this.$awn.success('Availability is set successfully')
          this.sttimes = ''
          this.endtime = ''
        })
      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
      }
    }
  },

  mounted: function () {
    var endDate = moment()
      .add(20, 'days')
      .format('ddd, DD MMM YYYY')
    var startDate = moment()
      .subtract(1, 'days')
      .format('ddd, DD MMM YYYY')
    var day1 = moment(endDate)
    var day2 = moment(startDate)
    var result = []

    while (day1.date() !== day2.date()) {
      day2.add(1, 'day')
      result.push(moment(day2))
    }
    this.list = result.map(x => x.format('DD MMM YYYY'))
    // console.log(result.map(x => x.format('DD MMM YYYY')))
  }
}
</script>

<style lang="scss" scoped>
.contenthead{
  font-size: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.form-row {
  display: flex;
  justify-content: space-evenly;
}
#add {
  width: 150px;
  margin: 10px;
  font-size: 20px;
}
.add {
  display: flex;
  justify-content: center;
  margin: 40px;
}
.myavail {
  display: flex;
  justify-content: center;
}
.time {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  font-size: 24px;
}
#timepicker {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
#starttime {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  text-align: center;
}
.grid-conatiner>ul>.nav::after,.nav::before{
  display: none;
}
.date-val {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(7, auto);
  font-size: 16px;
  row-gap: 5px;
  column-gap: 5px;
}
.date-val>li>a {
    position: relative;
    display: block;
    // padding: 14px 27px;
    font-size: 18px;
}
.date-val>li.active>a, .date-val>li.active>a:focus, .date-val>li.active>a:hover {
    color: #fff;
    background-color: #5bad2b;
        border-top-color: unset;
}
.date-p {
  // margin: 5px;
  text-align: center;
  background-color: #f4f4f4;
}
// button css
#myavailbtn {
  font-size:20px;
  color:#5bad2b;
  display: flex;
  column-gap: 10px;
  border-radius: 5px;
  background-color: transparent;
  all: unset;
}
.ibutton {
  font-size:18px; color:green ; align-items:center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
#exampleModalLongTitle {
    margin: 10px;
    line-height: 2;
    width: 95%;
    // padding-top: 20px;
    font-size: 26px;
    display: flex;
    justify-content: space-between;align-items: center;
}
#info{
  all: unset;
margin-left: 15px;
font-size: 18px;
}
.seTime{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
padding: 0 10px 0 10px;

}
#appt-time{
  width: 20%;
  font-size: 20px;
}
select{
  width: 100%;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: black;
  // margin: 0px 40px 0 0px;
  border:2px solid black;
}
.errormsg{
  color: red;
  font-size: 14px;
  font-weight: 400;
}
.dterrormsg{
  color: red;
  font-size: 14px;
  font-weight: 400;
  padding-left: 50px;
  text-align: center;
}
.col-form-label {
  font-size: 16px;
}
.head{
      margin-top: 20px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    flex-direction: row;
    background: #f7f7f7;
    padding: 10px;
}
.settime{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  }
  .myAvailability{
    border-radius: 10px ;
  }
  .modalclosebutton{
display: flex;
justify-content: center;
  }
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
.dterrormsg {
    color: red;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    padding: 0%;
}
.date-val {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
  overflow-x: scroll;
}
.date-val>li>a {
    position: relative;
    display: block;
    // padding: 14px 27px;
    font-size: 12px;
}
.timeshow{
width: 45%;
}
.contenthead{
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
#myavailbtn {
  font-size:14px;
  color:#5bad2b;
  display: flex;
  column-gap: 10px;
  border-radius: 5px;
  background-color: transparent;
  all: unset;
}
.ibutton {
    font-size:14px;
    color:green ;
    align-items:center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
#info{
  font-size: 14px;
}
.avabtn{
  width: 85px;
  height: 25px;
  font-size: 10px;
  }
  #activebtn{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
  width: 110px;
  height: 40px;
  text-align: center;
  font-size: 13px;
}
.sttime{
padding: 6px;
}
#add{
  width: 100px;
}
.add{
  margin: 5px;

}
}

  @media only screen and (min-device-width: 481px) and (max-device-width: 768px) {
.date-val {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 12px;
}
.date-val>li>a {
    position: relative;
    display: block;
    // padding: 14px 27px;
    font-size: 12px;
}
.timeshow{
width: 35%;
}
#activebtn{
  width: 115px;
  height: 45px;
  text-align: center;
  font-size: 14px;
}
.ibutton{
  font-size: 18px;
}
#info{
  font-size: 18px;
}
}

@media only screen and (min-device-width: 769px) and (max-device-width: 1024px) {
.date-val {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(7, auto);
  font-size: 16px;
}
.date-val>li>a {
    position: relative;
    display: block;
    // padding: 14px 27px;
    font-size: 14px;
}
#activebtn{
  width: 134px;
  height: 50px;
  text-align: center;
  font-size: 15px;
}
.ibutton{
  font-size: 18px;
}
#info{
  font-size: 18px;
}
}
</style>
